import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import { UserNotify } from "src/app/support/notify-decorator";
import { PageRequest } from "src/app/support/page-request";
import { Injectable } from "@angular/core";
import { Export, ExportStatus } from "../models/export";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { PaginatedResult } from "src/app/support/paginated-result";
import { map } from "rxjs/operators";

@Injectable()
export class ExportBackend {
  constructor(private http: HttpClient) {}

  load(id: string): Observable<Export> {
    return this.http
      .get<Export>(`${environment.snoots.api.healthcare}/exports/${id}`)
      .pipe(map(extendDoc));
  }

  list(request: PageRequest): Observable<PaginatedResult<Export>> {
    return this.http
      .get<PaginatedResult<Export>>(
        `${environment.snoots.api.healthcare}/exports`,
        {
          params: {
            p: request.page,
            s: request.pageSize
          }
        }
      )
      .pipe(
        map((result) => {
          return {
            ...result,
            docs: result.docs.map(extendDoc)
          };
        })
      );
  }

  @UserNotify({
    successMessage: marker("Esportazione rimossa"),
    errorMessage: marker("Impossibile rimuovere l'esportazione")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.healthcare}/exports/${id}`
    );
  }
}

function extendDoc(exports: Export): Export {
  return {
    ...exports,
    status:
      exports.status === ExportStatus.CREATED
        ? ExportStatus.IN_PROGRESS
        : exports.status
  };
}
